import { Component } from '@angular/core';
import { ChatCoreLiveComponent } from '@big-direkt/chat-core';

@Component({
    selector: 'big-chat-live',
    templateUrl: './live.component.html',
    standalone: false,
})
export class LiveComponent extends ChatCoreLiveComponent {}
